import React, { useState } from 'react'
import { Button, Col, Space, Form } from 'antd'
import { successNotification, postRequest, carTasksUrl } from '../../config'
import TextAreaInput from '../../components/Forms/TextAreaInput'
import SelectInput from '../../components/Forms/SelectInput'
import BasicInput from '../../components/Forms/BasicInput'
import WithData from 'hocs/WithData'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { CAR_VENDORS } from 'app-constants'
import PropTypes from 'prop-types'

const CarTaskForm = props => {
  const [payload, setPayload] = useState({
    type: '',
    carUrl: '',
    retries: 0,
    rawHtml: '',
    provideRawHtml: false
  })
  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleInputChange = stateName => event => {
    setPayload({ ...payload, [stateName]: event.target.value })
  }

  const handleSelect = stateName => value => {
    setPayload({
      ...payload,
      [stateName]: value
    })
  }

  const handleCreate = async event => {
    event.preventDefault()

    const response = await postRequest(
      `${carTasksUrl}`,
      {
        ...payload,
        rawHtml: payload.provideRawHtml ? payload.rawHtml : null
      },
      'car task',
      setLoading
    )

    if (response.success) {
      successNotification('New Car Task Created')
      props.handleCancel()
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Form className="p-2rem" layout="vertical">
            <div
              className="row"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
            >
              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Car Dealer"
                  name="type"
                  value={payload.type}
                  onChange={handleSelect('type')}
                  optionList={CAR_VENDORS}
                  required={false}
                />
                {serverErrors.type &&
                  serverErrors.type.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <TextAreaInput
                  label="Car URL"
                  value={payload.carUrl}
                  name={'carUrl'}
                  placeholder="carUrl"
                  handleChange={handleInputChange('carUrl')}
                  required={true}
                />

                {serverErrors.carUrl &&
                  serverErrors.carUrl.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label="Number of Retries"
                  value={payload.retries}
                  name={'retries'}
                  placeholder="retries"
                  handleChange={handleInputChange('retries')}
                  required={false}
                />
                {serverErrors.retries &&
                  serverErrors.retries.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5 mt-4">
                <label>
                  <input
                    type="checkbox"
                    checked={payload.provideRawHtml}
                    onChange={e =>
                      setPayload({
                        ...payload,
                        provideRawHtml: e.target.checked
                      })
                    }
                  />{' '}
                  Provide Raw HTML manually?
                </label>
              </div>

              {payload.provideRawHtml && (
                <div className="col-md-12 mt-4">
                  <TextAreaInput
                    label="Raw HTML"
                    value={payload.rawHtml}
                    name={'rawHtml'}
                    placeholder="Paste the car's page source here"
                    handleChange={handleInputChange('rawHtml')}
                    required={true}
                  />
                  {/* A phone cannot view-source, but Chrome's download icon saves the page as
                      .mhtml and the API reads that from text too (spec: phone-first-scraping). */}
                  <small className="text-muted">
                    Paste the page source, or the contents of a page saved from Chrome (download
                    icon &rarr; .mhtml).
                  </small>
                  {serverErrors.raw_html &&
                    serverErrors.raw_html.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              )}

              {serverErrors.nonFieldErrors &&
                serverErrors.nonFieldErrors.map((err, i) => (
                  <div className="text-danger" key={i}>
                    {err}
                  </div>
                ))}

              <Col md={24}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginBottom: '20px'
                  }}
                >
                  <Space>
                    {/* eslint-disable-next-line react/prop-types */}
                    <Button onClick={() => props.history.goBack()}>
                      Go Back
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleCreate}
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Space>
                </div>
              </Col>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

CarTaskForm.propTypes = {
  handleCancel: PropTypes.func
}

export default WithData(withRouter(CarTaskForm))
